import { t } from "@lingui/macro";
import { useDialog } from "@/client/stores/dialog";
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Form,
  FormField,
  FormItem,
  FormLabel,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  FormControl,
  SelectValue,
  SelectTrigger,
  ScrollArea,
  Input,
} from "@reactive-resume/ui";
import { useRef } from "react";
import { useForm } from "react-hook-form";
import { SelectFormField } from "../_components/select-form-fields";
import { usefilterUser } from "@/client/services/user/filter-user";

import { useFilterWithdrawal } from "@/client/stores/filter";
import { FilterWithdrawalType } from "libs/dto/src/withdrawal";

type StringFilterCondition = "startsWith" | "contains" | "equals" | "endsWith";
type DateFilterCondition = "gt" | "gte" | "equals" | "lt" | "lte";
type NumberFilterCondition = "gt" | "gte" | "equals" | "lt" | "lte";

export const FilterWithdrawalDialog = () => {
  type WithdrawalFilterFormType = {
    reference?: {
      condition: StringFilterCondition;
      value: string;
    };
    status?: {
      condition: NumberFilterCondition;
      value: string;
    };
    userId?: {
      condition: StringFilterCondition;
      value: string;
    };
    amount?: {
      condition: NumberFilterCondition;
      value: string;
    };
    demandDate?: {
      condition: DateFilterCondition;
      value: string;
    };
    decisionDate?: {
      condition: DateFilterCondition;
      value: string;
    };
  };

  const formRef = useRef<HTMLFormElement>(null);
  const { replaceFilter } = useFilterWithdrawal();
  const { filterUsers } = usefilterUser(false);
  let { open, isOpen, close } = useDialog("filter-withdrawal");

  const ObjectConversionToFilterType = (object: WithdrawalFilterFormType) => {
    const filter: FilterWithdrawalType = {};
    Object.entries(object).forEach(([key, field]) => {
      if (!field || field.value == null || Number.isNaN(field.value) || field.value === "") return;

      filter[key as keyof WithdrawalFilterFormType] = {
        [field.condition]: field.value,
      };
    });
    return filter;
  };

  const form = useForm<WithdrawalFilterFormType>({
    defaultValues: {
      reference: {
        condition: "equals",
        value: "",
      },
      status: {
        condition: "equals",
        value: "",
      },
      userId: {
        condition: "equals",
        value: "",
      },
      amount: {
        condition: "equals",
        value: "",
      },
      demandDate: {
        condition: "equals",
        value: "",
      },
      decisionDate: {
        condition: "equals",
        value: "",
      },
    },
  });

  const OnSubmit = (data: any) => {
    try {
      if (data.userId) data.userId.condition = "equals";
      if (data.status) data.status.condition = "equals";
      if (data.amount?.value) data.amount.value = Number(data.amount.value);
      //if(data.status?.value) data.status.value = Number(data.status.value);
      console.log(data);
      const filterData = ObjectConversionToFilterType(data);
      console.log(filterData);
      replaceFilter(filterData);
      form.reset();
      close();
    } catch {
      form.reset();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Filtrer les retraits</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form
            ref={formRef}
            onSubmit={form.handleSubmit(OnSubmit)}
            className="flex flex-col gap-y-4"
          >
            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label={t`Statut`}
                  form={form}
                  condition="String"
                  nameField="status.condition"
                  disabled
                />
                <FormField
                  name="status.value"
                  render={({ field }) => (
                    <FormItem className="w-full">
                      <Select
                        value={field.value}
                        onValueChange={(value) => {
                          field.onChange(value as any);
                        }}
                      >
                        <FormControl>
                          <SelectTrigger className="w-full">
                            <SelectValue placeholder="Choisir le status" />
                          </SelectTrigger>
                        </FormControl>
                        <SelectContent>
                          <SelectGroup>
                            <SelectLabel>Choisir le status</SelectLabel>
                            <SelectItem value="pending"> En attente</SelectItem>
                            <SelectItem value="accepted"> Accepté</SelectItem>
                            <SelectItem value="rejected"> Rejeté</SelectItem>
                          </SelectGroup>
                        </SelectContent>
                      </Select>
                    </FormItem>
                  )}
                />
              </div>
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Ambassadeur"
                  form={form}
                  condition="String"
                  nameField="userId.condition"
                  disabled
                />
                <FormField
                  name="userId.value"
                  render={({ field }) => (
                    <FormItem className="w-full">
                      <Select
                        value={field.value}
                        onValueChange={(value) => {
                          field.onChange(value);
                        }}
                      >
                        <FormControl>
                          <SelectTrigger className="w-full">
                            <SelectValue placeholder="Sélectionner un ambassadeur" />
                          </SelectTrigger>
                        </FormControl>
                        <SelectContent>
                          <ScrollArea orientation="vertical" className="h-[300px]">
                            {/* <SelectGroup> */}
                            {/* <SelectLabel>Selectionner un client</SelectLabel> */}
                            {filterUsers?.data
                              .slice()
                              .sort((a, b) => a.name.localeCompare(b.name))
                              .map((item) => {
                                return (
                                  <>
                                    <SelectItem value={item.id}>
                                      {" "}
                                      <span className="font-bold">{item.name}</span> ||{" "}
                                      <span className="text-moncvpro-secondary text-lg font-bold">
                                        {" "}
                                        {item.email}
                                      </span>
                                    </SelectItem>
                                  </>
                                );
                              })}
                            {/* </SelectGroup> */}
                          </ScrollArea>
                        </SelectContent>
                      </Select>
                    </FormItem>
                  )}
                />
              </div>
            </div>

            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Reference"
                  form={form}
                  condition="String"
                  nameField="reference.condition"
                />
                <Input {...form.register("reference.value")} />
              </div>
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Montant"
                  form={form}
                  condition="Number"
                  nameField="amount.condition"
                />
                <Input {...form.register("amount.value")} type="number" />
              </div>
            </div>
            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="demandDate"
                  form={form}
                  condition="Date"
                  nameField="demandDate.condition"
                />
                <Input {...form.register("demandDate.value")} type="date" />
              </div>
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="decisionDate"
                  form={form}
                  condition="Date"
                  nameField="decisionDate.condition"
                />
                <Input {...form.register("decisionDate.value")} type="date" />
              </div>
            </div>

            <div className="flex justify-center gap-x-3">
              <Button type="submit" className="bg-moncvpro-secondary">
                {"Valider"}
              </Button>
            </div>
          </form>
        </Form>
      </DialogContent>
      <DialogFooter></DialogFooter>
    </Dialog>
  );
};
